import React, { useEffect, useState } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Textarea,
  VStack,
  Heading,
  Button,
  Stack,
  NumberInput,
  NumberInputStepper,
  NumberDecrementStepper,
  NumberInputField,
  NumberIncrementStepper,
} from '@chakra-ui/react';
import CustomCheckbox from '../Components/CustomCheckBox';
import { DayWiseRecord, DayWiseVisitStatusRecord, MarketScanFormData, MarketScanFormPayload } from '../Constants/type';
import {useAppDispatch} from '../Hooks/useAppDispatch';
import {createMarketScanRecord, selectMarketScanRecord, updateMarketScanRecordById} from '../Redux/MarketScanSlice';
import {useNavigate, useParams} from 'react-router-dom';
import {useAppSelector} from '../Hooks/useAppSelector';
import Toast from '../Components/Toast';
import EditableInputText from '../Components/EditableInput';
import EditableSelect from '../Components/EditableSelect';
import {themeConfig} from '..';
import {getRole} from '../Redux/AdminSlice';



const MarketScanForm: React.FC = () => {
  let { type } = useParams();

  const isEditing=type==="edit"?true:false;

  let record:MarketScanFormData=useAppSelector(selectMarketScanRecord);
  if (!isEditing) {
      record={
        id:'',
        visited_at: '',
        address: '',
        shop_name: '',
        shop_size: '',
        landmarks: [],
        area_description: '',
        road_description: '',
        product_categories: [],
        visit_status: [] as DayWiseVisitStatusRecord[],
        decision_makers: 0,
        influencers: 0,
        conversion_chances: [] as DayWiseRecord[],
        openness: [] as DayWiseRecord[],
        ownership: '',
        owner_name: '',
        contact_number: '',
        notes: [] as DayWiseRecord[],
        image_link: '',
      }
  }

  const role=useAppSelector(getRole)
  console.log(role);

  const [visitedAt, setVisitedAt] = useState(record.visited_at);
  const [address, setAddress] = useState(record.address );
  const [shopName, setShopName] = useState(record.shop_name);
  const [shopSize, setShopSize] = useState(record.shop_size);
  const [areaDescription, setAreaDescription] = useState(record.area_description);
  const [roadDescription, setRoadDescription] = useState(record.road_description);

  //Get the latest visit status or anything
  //[spke,visit later];
  const [visitStatus, setVisitStatus] = 
    useState<String[]>(record.visit_status[record.visit_status.length-1]?.val || []);

  //[{val:[spke,visit later],timeStamp:"something"}];
  const [visitStatusArr,setVisitStatusArr]=useState<DayWiseVisitStatusRecord[]>(record.visit_status);

  const [conversionChances, setConversionChances] = useState(record.conversion_chances[record.conversion_chances.length - 1]?.val || 0);
  const [conversionChanceArr,setConversionChanceArr]=useState<DayWiseRecord[]>(record.conversion_chances);

  const [openness, setOpenness] = useState(record.openness[record.openness.length - 1]?.val || 0);
  const [opennessArr,setOpennessArr]=useState<DayWiseRecord[]>(record.openness);

  const [notes, setNotes] = useState(record.notes[record.notes.length-1]?.val || '');
  const [notesArr,setNotesArr]=useState<DayWiseRecord[]>(record.notes);

  const [decisionMakers, setDecisionMakers] = useState(record.decision_makers);
  const [influencers, setInfluencers] = useState(record.influencers);
  const [ownership, setOwnership] = useState(record.ownership);
  const [ownerName, setOwnerName] = useState(record.owner_name);
  const [contactNumber, setContactNumber] = useState(record.contact_number);
  const [landmarks,setLandmarks]=useState<String[]>(record.landmarks);
  const [productsDetails,setProductDetails]=useState<String[]>(record.product_categories);

  const navigate=useNavigate();

  const dispatch=useAppDispatch();

  const options = [
    'Packaged F&B refrigerated',
    'Packaged F&B non-refrigerated',
    'Fresh fruits and vegies',
    'Fresh dairy',
    'Staples',
    'Tobacco',
    'Oral care',
    'Bath & body care',
    'Hair care',
    'Makeup',
    'Cleaning supplies (CS) - house',
    'CS - kitchen',
    'CS - Bathroom',
    'Medicines (prescribed)',
    'Medicines (OTC)',
    'Apparel (hosiery)',
    'Apparel (Regular)',
    'Apparel (Footwear)',
    'Electronics (Personal elec.)',
    'Electronices (Accessories)',
    'Electronics (Large Appliances)'
  ];

  const landmarksData = [
    "School/College",
    "Office",
    "Mall",
    "Religious site",
    "Residential society",
    "Tourist spot",
  ];

  const visitStatusData=[
      "Did not visit",
      "Did not entertain",
      "Come later",
      "Spoke",
      "Left flyer",
      "Asked questions",
      "Seemed Interested",
  ]

  function getLatestOpennessArr() {
    return [...opennessArr,{val:openness,timeStamp:new Date().toLocaleString()}];
  }

  function getLatestConversionChancesArr() {
    return [...conversionChanceArr,{val:conversionChances,timeStamp:new Date().toLocaleString()}];
  }


  function getLatestNotesArr() {
    return [...notesArr,{val:notes,timeStamp:new Date().toLocaleString()}];
  }

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    let market_scan_record:MarketScanFormData={
      id:'',
      visited_at:visitedAt,
      address:address,
      shop_name:shopName,
      shop_size:shopSize,
      landmarks:landmarks,
      area_description:areaDescription,
      road_description:roadDescription,
      product_categories:productsDetails,
      visit_status:[...visitStatusArr,{val: visitStatus, timeStamp:new Date().toLocaleString() }],
      decision_makers:decisionMakers,
      influencers:influencers,
      conversion_chances:getLatestConversionChancesArr(),
      openness:getLatestOpennessArr(),
      ownership:ownership,
      owner_name:ownerName,
      contact_number:contactNumber,
      notes:getLatestNotesArr(),
      image_link:"",
    };
    let payload:MarketScanFormPayload={
      market_scan_record:market_scan_record,
      role:role,
    }
    if (isEditing) {
      dispatch(updateMarketScanRecordById(
        payload,
        record.id,
        ()=>{ navigate('/market-scan')},
      ))
    }else{
      dispatch(createMarketScanRecord(
        payload,
        ()=>{ navigate('/market-scan') }
      ));
    }
  };

  return (
    <Box p={4} position={"relative"}>
      <Toast/>
      <Heading as="h1" mb={4}>Market Scan Form</Heading>
      <form  onSubmit={handleFormSubmit}>

        <EditableInputText
          id='visited_at'
          label='Visited At'
          value={visitedAt}
          isEditing={isEditing}
          type='date'
          onEdit={(e) => setVisitedAt(e.target.value)}
        />

        <EditableInputText
          id='address'
          label='Address'
          value={address}
          isEditing={isEditing}
          type='text'
          onEdit={(e) => setAddress(e.target.value)}
        />


        <EditableInputText
          id='shopName'
          label='Shop Name'
          value={shopName}
          isEditing={isEditing}
          type='text'
          onEdit={(e) => setShopName(e.target.value)}
        />


        <FormLabel mb={2}>Shop Description</FormLabel>
        <Box border="1px solid #CBD5E0" borderRadius="md" p={4} mb={4}>

          <EditableSelect
            label="Shop Size"
            isEditing={isEditing}
            value={shopSize}
            onChange={(e) => setShopSize(e.target.value)}
            options={['Very Big', 'Big', 'Standard', 'Small', 'Micro']}
          />

          <FormControl id="landmarks" my={5}>
            <FormLabel>Landmarks</FormLabel>
            <Stack>
              {
                landmarksData.map((landmark:string) => (
                  <CustomCheckbox
                    key={landmark}
                    isChecked={record.landmarks.includes(landmark)}
                    label={landmark} 
                    onChange={(isChecked) => {
                      if (isChecked) {
                        setLandmarks([...landmarks, landmark]);
                      } else {
                        setLandmarks(landmarks.filter((item) => item !== landmark));
                      }
                    }}
                  />
                ))
              }
            </Stack>
          </FormControl>

          <EditableSelect
            label="Area Description"
            options={["Residential", "Commercial - Organised", "Commercial - Unorganised", "Mixed"]}
            value={areaDescription}
            isEditing={isEditing}
            onChange={(e) => setAreaDescription(e.target.value)}
          />

          <EditableSelect
            label="Road Description"
            options={["Main road", "Side road", "Junction/ Crossing"]}
            value={roadDescription}
            isEditing={isEditing}
            onChange={(e) => setRoadDescription(e.target.value)}
          />

          <FormControl id="productCategories" mb={2} mt={5}> 
            <FormLabel>Products/Categories Sold</FormLabel>
              <VStack alignItems="start">
                {options.map((opt) => {
                  return (
                    <Box key={opt}>
                      <CustomCheckbox
                        isChecked={record.product_categories.includes(opt)}
                        label={opt}
                        onChange={(isChecked: boolean) => {
                          if (isChecked) {
                            setProductDetails([...productsDetails, opt]);
                          } else {
                            setProductDetails(productsDetails.filter(item => item !== opt));
                          }
                        }}
                      />
                    </Box>
                  );
                })}
              </VStack>
          </FormControl>
        </Box>

        <FormLabel>Visit Status</FormLabel>
        <Box border="1px solid #CBD5E0" borderRadius="md" p={4} mb={4}>
          <FormControl id="visitStatus" > 
            <VStack alignItems="start">
              {visitStatusData.map((opt) => {
                return (
                  <Box key={opt}>
                    <CustomCheckbox
                      isChecked={visitStatus.includes(opt)}
                      label={opt}
                      onChange={(isChecked: boolean) => {
                        if (isChecked) {
                          setVisitStatus([...visitStatus, opt]);
                        } else {
                          setVisitStatus(visitStatus.filter(item => item !== opt));
                        }
                      }}
                    />
                  </Box>
                );
              })}
            </VStack>
          </FormControl>
        </Box>

        {/* <FormControl id="visitStatus" mb={4}> */}
        {/*   <FormLabel>Visit Status</FormLabel> */}
        {/*   <Select value={visitStatus} */} 
        {/*     onChange={(e) => { */}
        {/*       const selectedValue = e.target.value; */}
        {/*       setVisitStatus(selectedValue); */}
        {/*   }} */}
        {/*     onBlur={()=>{ */}
        {/*       setVisitStatusArr(prevArr => [...prevArr, {val: visitStatus, timeStamp:new Date().toLocaleString() }]); */}
        {/*     }} */}
        {/*   > */}
        {/*     <option disabled selected hidden> */}
        {/*       {''} */}
        {/*     </option> */}
        {/*     <option value="Did not visit">Did not visit</option> */}
        {/*     <option value="Did not entertain">Did not entertain</option> */}
        {/*     <option value="Come later">Come Later</option> */}
        {/*     <option value="Spoke">Spoke</option> */}
        {/*     <option value="Left flyer">Left flyer</option> */}
        {/*     <option value="Asked questions">Asked questions</option> */}
        {/*     <option value="Seemed Interested">Seemed Interested</option> */}
        {/*   </Select> */}
        {/* </FormControl> */}

        <FormLabel mb={2} >Additional Info</FormLabel>
        <Box border="1px solid #CBD5E0" borderRadius="md" p={4} mb={4}>
          <EditableInputText
            id="decisionMakers"
            label="No. of decision makers"
            value={decisionMakers}
            isEditing={isEditing}
            type="number"
            onEdit={(e) => setDecisionMakers(Number(e.target.value))}
          />
          {/* <FormControl id="decisionMakers" mb={2}> */}
          {/*   <FormLabel>No. of decision makers</FormLabel> */}
          {/*   <Input type="number" value={decisionMakers} onChange={} /> */}
          {/* </FormControl> */}

          <EditableInputText
            id="influencers"
            label="No. of influencers"
            value={influencers}
            isEditing={isEditing}
            type="number"
            onEdit={(e) => setInfluencers(Number(e.target.value))}
          />

          <FormControl id="conversionChances" mb={2}>
            <FormLabel>Conversion Chances</FormLabel>
            <NumberInput value={conversionChances} min={1} max={10} 
              onChange={(val) => {
                const selectedValue=parseInt(val);
                setConversionChances(selectedValue)
              }}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>

          <FormControl id="openness" mb={2}>
            <FormLabel>Openness</FormLabel>
            <NumberInput value={openness} min={1} max={10} 
              onChange={(val) => {
                const selectedValue = parseInt(val);
                setOpenness(selectedValue)
              }}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>
        </Box>

        <FormLabel mb={2}>Owner Contact Details</FormLabel>
        <Box border="1px solid #CBD5E0" borderRadius="md" p={4} mb={4}>

          <EditableSelect
            label="Ownership"
            value={ownership}
            isEditing={isEditing}
            options={["Franchise", "Family owned"]}
            onChange={(e) => setOwnership(e.target.value)}
          />

          <EditableInputText
            id='ownerName'
            label='Owner Name'
            value={ownerName}
            isEditing={isEditing}
            type='text'
            onEdit={(e) => setOwnerName(e.target.value)}
          />

          <EditableInputText
            id='contactNumber'
            label='Contact Number'
            value={contactNumber}
            isEditing={isEditing}
            type='tel'
            onEdit={(e) => setContactNumber(e.target.value)}
          />

        </Box>

        <FormControl id="notes" mb={5}>
          <FormLabel>Notes and Comments</FormLabel>
          <Textarea value={notes} 
            onChange={(e) => {
              const selectedValue = e.target.value;
              setNotes(selectedValue);
            }}
          />
        </FormControl>
        <Button type="submit" backgroundColor={themeConfig.colors.green0} w={"full"}>{isEditing?"Update":"Submit"}</Button>
      </form>
    </Box>
  );
};

export default MarketScanForm;
